export default "__VITE_ASSET__8200ef3d__"